import type { RootState } from '@/store';

import { cadeiaNaoConfirmada } from '../utils/cadeiaDoDocumento';

export const selectConsultaResult = (state: RootState) => state.autenticacaoPublica.consultaResult;

export const selectVerificacaoResult = (state: RootState) =>
  state.autenticacaoPublica.verificacaoResult;

export const selectDownloadStatus = (state: RootState) => state.autenticacaoPublica.downloadStatus;

export const selectIsLoadingConsulta = (state: RootState) =>
  state.autenticacaoPublica.isLoadingConsulta;

export const selectIsLoadingVerificacao = (state: RootState) =>
  state.autenticacaoPublica.isLoadingVerificacao;

export const selectIsLoadingDownload = (state: RootState) =>
  state.autenticacaoPublica.isLoadingDownload;

export const selectErrorConsulta = (state: RootState) => state.autenticacaoPublica.errorConsulta;

export const selectErrorVerificacao = (state: RootState) =>
  state.autenticacaoPublica.errorVerificacao;

export const selectErrorDownload = (state: RootState) => state.autenticacaoPublica.errorDownload;

export const selectRateLimitRetryAfter = (state: RootState) =>
  state.autenticacaoPublica.rateLimitRetryAfter;

/**
 * O resultado na tela tem a cadeia de hash não confirmada (divergente ou não verificada). A página
 * então não exibe a garantia institucional de que a criptografia "impede qualquer alteração
 * posterior à emissão" (core#1186, D-03). Com `false`, é a régua com que o Certificado de Acessos
 * suprime o parágrafo de prevenção de adulteração. Com `null`, a página vai além do certificado,
 * que segue afirmando a prevenção (`afirmaPrevencaoDeAdulteracao` só olha `false`): aqui a cadeia
 * não verificada nunca afirma (DP-3). "Alinhar" as duas réguas no `null` regride a página.
 */
export const selectIntegridadeNaoConfirmada = (state: RootState): boolean => {
  const { consultaResult, verificacaoResult } = state.autenticacaoPublica;
  const resultado =
    consultaResult?.status === 'VALID'
      ? consultaResult
      : verificacaoResult?.status === 'VALID'
        ? verificacaoResult
        : null;
  return resultado !== null && cadeiaNaoConfirmada(resultado) !== null;
};
